<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="formGeneral">
        </sm-form>
        <sm-form *ngIf="formSpecific != null" [form]="formSpecific">
        </sm-form>
        <p-button icon="fas fa-run" label="Starten" (onClick)="start()"></p-button>
    </p-panel>
    <p-tabView *ngIf="registeredWatchers?.length > 0" class="flex-item-fill height100p full-height direct-sub" [(activeIndex)]="activeWatcherTab" (onChange)="changeTab()">
        <p-tabPanel *ngFor="let watcher of registeredWatchers" [header]="watcher.guid">
            <div class="flex-col height100p">
                <sm-toolbar>
                </sm-toolbar>
                <sm-table2 *ngIf="resultsTable != null" class="flex-item-fill height100p" [data]="resultsTable"></sm-table2>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
